import './swiper'
import './moment'
import '@fortawesome/fontawesome-pro/css/all.css'

/* PIKADAY */
import './pikaday'
// import 'pikaday/css/pikaday.css'
